import { render, staticRenderFns } from "./ClientItem.vue?vue&type=template&id=cb581334&"
import script from "./ClientItem.vue?vue&type=script&lang=js&"
export * from "./ClientItem.vue?vue&type=script&lang=js&"
import style0 from "./ClientItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports